export default __webpack_public_path__ + "images/nydree-logo.7d44feb10a774f1f2337fa805e65c00d.png";